import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/jjfa/jiangben.png'


const _hoisted_1 = { class: "medical-treatment" }
const _hoisted_2 = { class: "fzqj-box" }
const _hoisted_3 = { class: "fzqj" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "fays" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "yycj" }
const _hoisted_11 = { class: "yycj-content" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "title" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "title" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "title" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "yyal"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "detail" }
const _hoisted_27 = {
  key: 1,
  style: {"height":"120rem","background":"#fff"}
}

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'MedicalTreatment',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref([])
const prospects: any = ref(
  [
  {
    title: '医疗资源分配不均',
    content: '由于医疗资源分配不均，欠发达地区比较难接触到最先进的医学研究成果和预防知识普及。',
  },
  {
    title: '传统康复成本高昂',
    content: '患者接受规范的康复治疗需要专业的设备辅助，对从业人员的专业水平要求较高，成本也较高。',
  },
  {
    title: '传统医疗培训效果欠佳',
    content: '参加医学培训需要承担高昂的线下时间成本和差旅费用，并且在培训中观察的视角也受到限制，影响培训效果。',
  }
]
)

const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesList.value.length === 0) {
    selectCommonElement({ columnId: 4 }).then((res: any) => {
      casesList.value = [...res].filter(e => e.industry == 4).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0))
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.zengxiao) {
    const zengxiao: any = await asynchronousRetrieval('nfznxr-images/jjfa/zengxiao.png');
    const yycj_img8: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img8.png');
    const yycj_icon8: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon8.png');
    const yycj_icon9: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon9.png');
    const yycj_img9: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img9.png');
    const yycj_img10: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img10.png');
    const yycj_icon10: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon10.png');
    const yiliao_f1: any = await asynchronousRetrieval('nfznxr-images/jjfa/yiliao_f1.png');
    const yiliao_f1_icon: any = await asynchronousRetrieval('nfznxr-images/jjfa/yiliao_f1_icon.png');
    const yiliao_f2: any = await asynchronousRetrieval('nfznxr-images/jjfa/yiliao_f2.png');
    const yiliao_f2_icon: any = await asynchronousRetrieval('nfznxr-images/jjfa/yiliao_f2_icon.png');
    const yiliao_f3: any = await asynchronousRetrieval('nfznxr-images/jjfa/yiliao_f3.png');
    const yiliao_f3_icon: any = await asynchronousRetrieval('nfznxr-images/jjfa/yiliao_f3_icon.png');
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    loadUrl.value = { zengxiao, yycj_img8, yycj_icon8, yycj_icon9, yycj_img9, yycj_img10, yycj_icon10, yiliao_f1, yiliao_f1_icon, yiliao_f2, yiliao_f2_icon, yiliao_f3, yiliao_f3_icon, fays_bg }

    prospects.value[0].url = yiliao_f1;
    prospects.value[0].src = yiliao_f1_icon;
    prospects.value[1].url = yiliao_f2;
    prospects.value[1].src = yiliao_f2_icon;
    prospects.value[2].url = yiliao_f3;
    prospects.value[2].src = yiliao_f3_icon;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title-font-style" }, "医疗解决方案", -1)),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "illustrate" }, [
      _createElementVNode("div", null, "利用元宇宙/VR技术实现医术培训、康复治疗、病理研究和预防知识普及、病情评估等，并能为不同地区提供高水平医疗服务，减少就医成本和时间，改善医疗资源分配和利用，对整个医疗行业产生积极变革。")
    ], -1)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "subtitle" }, "行业痛点", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prospects.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("img", {
              src: item.url
            }, null, 8, _hoisted_4),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.src
                }, null, 8, _hoisted_6),
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("div", null, _toDisplayString(item.content), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "subtitle" }, "方案优势", -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_8),
      _cache[2] || (_cache[2] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: _imports_0
        }),
        _createElementVNode("div", { class: "l2" }, "降低成本"),
        _createElementVNode("div", { class: "l3" }, "基于VR设备配合医学培训、康复治疗、医疗研究等，能高效打通信息共享的途径，降低成本。")
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: loadUrl.value.zengxiao
        }, null, 8, _hoisted_9),
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "l2",
          style: {"margin-top":"12rem"}
        }, "提升效率", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "l3" }, "VR医疗方案可以让医学生近距离接触及学习不同类型的医疗模型，在医疗培训过程中以第一视角观察操作步骤，也能让康复患者跟随VR系统指令复健，显著提升效率。", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "subtitle" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img8,
            class: "left-radius"
          }, null, 8, _hoisted_12),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon8
              }, null, 8, _hoisted_14),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "医疗培训", -1))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "content" }, "交互式培训模拟，随时复盘教学。", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon9,
                class: "right-radius"
              }, null, 8, _hoisted_16),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "康复治疗", -1))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "content" }, "可视化康复指导，协同康复，高效精准。", -1))
          ]),
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img9
          }, null, 8, _hoisted_17)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img10,
            class: "left-radius"
          }, null, 8, _hoisted_18),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon10
              }, null, 8, _hoisted_20),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "医学科普", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "content" }, "演示病理特性，传播预防知识。", -1))
          ])
        ])
      ])
    ]),
    (casesList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "subtitle" }, "应用案例", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(casesList.value, (caseItem) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "yyal-content",
              key: caseItem.id
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (toOtherPath(`/case_detail?id=${caseItem.id}&pathName=解决方案,医疗解决方案,应用案例`, ['解决方案', '医疗解决方案', '应用案例']))
              }, [
                _createElementVNode("img", {
                  src: caseItem.ossPath
                }, null, 8, _hoisted_23),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(caseItem.title), 1),
                  _createElementVNode("div", null, _toDisplayString(caseItem.subTitle), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(caseItem.introduction), 1)
                ])
              ], 8, _hoisted_22)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_27))
  ]))
}
}

})